import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { isLength, isMatch } from '../../../utils/validation/Validation'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import Navbar from '../../Navbar/Navbar'
import { appAddress } from '../../../App'

const initialState = {
    password: '',
    cf_password: ''
}

export default function ResetPassword() {
    const [data, setData] = useState(initialState)
    const {token} = useParams()
    // const navitage = useNavigate()

    const {password, cf_password} = data

    const handleChangeInput = e => {
        const {name, value} = e.target
        setData({...data, [name]:value})
    }

    const handleResetPass = async () => {
        if(isLength(password))
            return toast.error('password must be mor than 6 characters', {
                position:"bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
            setData({...data})

        if(isMatch(password, cf_password))
            return toast.error('The password is not the same', {
                position:"bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
                setData({...data})

        try {
            // const res = await axios.post(`/user/reset`, {password}, {
            const res = await axios.post(`${appAddress}/user/reset`, {password}, {
                headers: {Authorization: token}
            })
            toast.success(res.data.msg, {
                position:"bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setData({...data})
            // navitage('/home')
        } catch (err) {
            toast.error(err.response.data.msg, {
                position:"bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
                setData({...data})
        }
    }


  return (
    <div className='w-[100%] h-[830px] desktop:h-[88vh] lbgImage'>
        <header>
            <Navbar />
        </header>
        
        <div className='w-[100%] h-full flex flex-col justify-center items-center'>
        <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl
              pauseOnFocusLoss
              draggable
              pauseOnHover/>
            <div className='lbgBlur w-[95%] h-[400px] desktop:w-[40%] desktopXl:w-[30%] desktop:h-[320px] flex flex-col justify-around items-center'>
                <div className='w-full h-[50px] flex items-center justify-center p-4 mt-4'>
                    <h1 className='text-3xl uppercase font-serif'>Reset password</h1>
                </div>
                <div className=' w-[100%] h-[200px] flex flex-col gap-6 justify-center items-center'>
                    <h5 className='text-slate-800'>please enter new password</h5>
                    <input className='w-[65%] p-2 rounded-lg bg-gray-800 text-white text-center' type="password" name='password' id='password' value={password} onChange={handleChangeInput} placeholder='new password'/>
                    <input className='w-[65%] p-2 rounded-lg bg-gray-800 text-white text-center' type="password" name='cf_password' id='cf_password' value={cf_password} onChange={handleChangeInput} placeholder='confirm new password'/>
                    <button className='w-[30%] tablet:w-[25%] desktop:w-[25] desktopXL:w-[17%] p-2 mb-4 rounded-lg font-serif bg-gray-800 text-white hover:bg-slate-200 hover:text-gray-800' onClick={handleResetPass}>Confirm</button>
                </div>
            </div>
        </div>
    </div>
  )
}
